<ng-container *ngIf="comments?.length; else noComments">
  <div *ngFor="let comment of comments" class="comment-item">
    <span class="comment-timestamp">{{ comment.creationTimestamp | date:'short' }}</span>
    <span *ngIf="comment.createdByUserGroupName" class="comment-author">{{ comment.createdByUserGroupName }}</span>
    <span class="comment-text">{{ comment.comment }}</span>
  </div>
</ng-container>

<ng-template #noComments>
  <p class="no-comments">{{ 'dataManagement.dataExchangeRequests.comments.noComments' | transloco }}</p>
</ng-template>

<div *ngIf="canAddComment" class="add-comment">
  <mat-form-field appearance="outline" class="full-width comment-form-field">
    <mat-label>{{ 'dataManagement.dataExchangeRequests.comments.addComment' | transloco }}</mat-label>
    <textarea matInput class="no-resize-textarea" [formControl]="commentControl"></textarea>
  </mat-form-field>
  <button mat-raised-button color="primary" type="button"
    [disabled]="!commentControl.value?.trim()"
    (click)="submit()">
    {{ 'dataManagement.dataExchangeRequests.comments.submit' | transloco }}
  </button>
</div>
